<template>
  <div
    v-if="show && customer"
    class="customer-popup-overlay"
    @click.self="$emit('close')"
  >
    <div class="customer-popup-content">
      <!-- Header -->
      <div class="customer-popup-header">
        <div>
          <h3 class="customer-popup-title">{{ customer.name }}</h3>
          <p class="customer-popup-subtitle">Customer Details</p>
        </div>
        <button @click="$emit('close')" class="customer-popup-close" aria-label="Close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      
      <!-- Body -->
      <div class="customer-popup-body">
        <!-- Customer Information -->
        <div class="customer-popup-section">
          
          <div class="customer-popup-data-row">
            <div class="customer-popup-label">Address:</div>
            <div class="customer-popup-value">{{ customer.address || 'N/A' }}</div>
          </div>
          
          <div class="customer-popup-data-row">
            <div class="customer-popup-label">City:</div>
            <div class="customer-popup-value">{{ customer.city || 'N/A' }}</div>
          </div>
          
          <div class="customer-popup-data-row">
            <div class="customer-popup-label">State:</div>
            <div class="customer-popup-value">{{ customer.state || 'N/A' }}</div>
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="customer-popup-footer">
        <button @click="$emit('close')" class="customer-popup-button">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerPopup',
  
  props: {
    customer: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  
  mounted() {
    // Add ESC key listener
    document.addEventListener('keydown', this.handleEscKey);
  },
  
  beforeDestroy() {
    // Remove ESC key listener
    document.removeEventListener('keydown', this.handleEscKey);
  },
  
  methods: {
    handleEscKey(event) {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    }
  }
};
</script>
